import { Grid } from "@material-ui/core";
import {
  InputReactDatepicker,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import React, { useContext } from "react";

import { toLastHoursDay } from "utils/dates";
import { isNull } from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { STATE_FILTER_TAGIHAN } from "../helpers";

function FormFilterDataRekapTagihan({
  fetchData,
}) {
  const {
    formFilterTagihan,
    setFormFilterTagihan
  } = useContext(FormContext);
  // console.log("totalDataTagihan", totalDataTagihan);

  const handleChange = (text) => (e) => {
    setFormFilterTagihan({
      ...formFilterTagihan,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetchData();
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3} className={"p1"}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              <Grid item sm={4}>
                <InputTextMaster
                  name="id_tagihan"
                  label="ID TAGIHAN"
                  id="id_tagihan"
                  value={formFilterTagihan.id_tagihan}
                  onChange={handleChange("id_tagihan")}
                  placeholder="ID Tagihan"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="guarantor_name"
                  label="NAMA PENANGGUNG"
                  id="guarantor_name"
                  value={formFilterTagihan.guarantor_name}
                  onChange={handleChange("guarantor_name")}
                  placeholder="Nama Penanggung"
                />
              </Grid>

              <Grid item sm={4}>
                <InputReactDatepicker
                  selected={formFilterTagihan.tanggal_awal}
                  label="TANGGAL"
                  isClearable
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  handleChangeToday={(e) =>
                    setFormFilterTagihan({
                      ...formFilterTagihan,
                      tanggal_awal: e,
                    })
                  }
                  onChange={(e) =>
                    !isNull(e) ? 
                    setFormFilterTagihan({
                      ...formFilterTagihan,
                      tanggal_awal: e,
                      tanggal_akhir: toLastHoursDay(new Date(e)),
                    }) :
                    setFormFilterTagihan({
                      ...formFilterTagihan,
                      tanggal_awal: "",
                      tanggal_akhir: "",
                    })
                  }
                  withPeriode={true}
                >
                  <button
                    type={"button"}
                    onClick={null}
                    style={{
                      borderLeft: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderRight: "1px solid #EAEAEA",
                      background: "#fff",
                      padding: "0 0.8rem 0 0.8rem",
                      cursor: "pointer",
                      // borderRadius: "6px 0 0 6px",
                      fontSize: "10px",
                    }}
                  >
                    s/d
                  </button>
                  <InputReactDatepicker
                    selected={formFilterTagihan.tanggal_akhir}
                    label=""
                    isClearable
                    dateFormat="dd/MM/yyyy HH:mm"
                    timeFormat="HH:mm"
                    showTimeSelect
                    timeIntervals={5}
                    minDate={new Date(formFilterTagihan.tanggal_awal)}
                    handleChangeToday={(e) =>
                      setFormFilterTagihan({
                        ...formFilterTagihan,
                        tanggal_akhir: e,
                      })
                    }
                    onChange={(e) =>
                      isNull(e) ?
                      setFormFilterTagihan({
                        ...formFilterTagihan,
                        tanggal_akhir: "",
                      }) :
                      setFormFilterTagihan({
                        ...formFilterTagihan,
                        tanggal_akhir: e,
                      })
                    }
                    withParentPeriode={true}
                  />
                </InputReactDatepicker>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="mb-2"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilterTagihan(STATE_FILTER_TAGIHAN)}
          />

          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
      </form>
    </>
  );
}

export default FormFilterDataRekapTagihan;
